import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deletePaymentServiceAllocationOperation = async (
  allocationId: number,
  userId: number,
  setLoading: (loading: boolean) => void,
  onDone?: () => void,
): Promise<void> => {
  try {
    setLoading(true);

    const res = await appApi.deletePaymentServiceAllocation(allocationId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    const updatedUserDetails = await appApi.getUserStudentDetails(userId);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('שירות התשלום הוסר בהצלחה');
    onDone?.();
  } catch (error) {
    console.error('Error deleting payment service allocation:', error);
    toast.error('מחיקת שירות התשלום נכשלה, נסה שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
